import React, { useEffect, useState, useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';

let lastPositionX = 0;
let lastPositionY = 0;

const CanvasLayer:React.FC<IProps> = (props) => {

  const canvas = useRef<HTMLCanvasElement>(null);
  const [crop, setCrop] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [cropping, setCropping] = useState("none");
  const [clicked, setClicked] = useState(false);
  const [contentTop, setContentTop] = useState(0);
  const [contentLeft, setContentLeft] = useState(0);
  const [contentWidth, setContentWidth] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [text, setText] = useState("");

  useEffect(() => {
    if (props.child.text) setText(props.child.text.text);
    var base_image = new Image();
    base_image.src = props.child.canvas;
    base_image.onload = function(){
      if (canvas.current) {
        canvas.current.width = props.dimensions.width;
        canvas.current.height = props.dimensions.height;
        var ctx = canvas.current.getContext('2d');
        if (ctx) {
          ctx.globalAlpha = props.child.opacity;
          ctx.drawImage(base_image, props.child.left, props.child.top);
          setContentTop(props.child.top);
          setContentLeft(props.child.left);
          const canvasWidth = props.child.right  - props.child.left;
          const canvasHeight = props.child.bottom - props.child.top;
          setContentWidth(canvasWidth);
          setContentHeight(canvasHeight);
          if (props.child.effects?.solidFill?.length > 0 && props.child.effects?.solidFill[0]?.enabled === true) {
            var imageData = ctx.getImageData(0, 0, props.dimensions.width, props.dimensions.height);
            ctx.clearRect(0, 0, props.dimensions.width, props.dimensions.height);
            const color = props.child.effects.solidFill[0].color;
            const opacity = props.child.effects.solidFill[0].opacity;
            ctx.fillStyle = `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity})`;
            ctx.fillRect(props.child.left, props.child.top, canvasWidth, canvasHeight);
            var effect_imageData = ctx.getImageData(0, 0, props.dimensions.width, props.dimensions.height);
            const data = imageData.data;
            const mask_data = effect_imageData.data;
            for (var i = 0; i < data.length; i += 4) {
              data[i]     = mask_data[i];
              data[i + 1] = mask_data[i + 1];
              data[i + 2] = mask_data[i + 2];
            }
            ctx.putImageData(imageData, 0, 0);
          }
          if (props.child.mask?.disabled === false) {
            var imageData = ctx.getImageData(0, 0, props.dimensions.width, props.dimensions.height);
            var mask_base_image = new Image();
            mask_base_image.src = props.child.mask.canvas;
            mask_base_image.onload = function(){
              if (ctx) {
                ctx.clearRect(0, 0, props.dimensions.width, props.dimensions.height);
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(props.child.left, props.child.top, canvasWidth, canvasHeight);
                ctx.drawImage(mask_base_image, props.child.mask.left, props.child.mask.top);
                var mask_imageData = ctx.getImageData(0, 0, props.dimensions.width, props.dimensions.height);
                const data = imageData.data;
                const mask_data = mask_imageData.data;
                let isVector = props.child.vectorFill ? true : false;
                for (var i = 0; i < data.length; i += 4) {
                  data[i + 3] = data[i + 3] > 0 ?
                    isVector ? 
                      data[i + 3] * (mask_data[i] + mask_data[i + 1] + mask_data[i + 2]) * (1 - (data[i] + data[i + 1] + data[i + 2]) / 755) / 755 
                    : data[i + 3] * (mask_data[i] + mask_data[i + 1] + mask_data[i + 2]) / 755 
                  : data[i + 3]; // opacity
                }
                ctx.putImageData(imageData, 0, 0);
              }
            }
          }
        }
      }
    }
  }, [])

  useEffect(() => {
    if (clicked === true && crop === false) {
      handleMove(props.coors);
    } 
    if (crop === true && cropping !== "none") {
      handleCropping(props.coors);
    }
  }, [props.coors])

  useEffect(() => {
    if (props.mouse === false) {
      setClicked(props.mouse);
      setCropping("none");
    }
  }, [props.mouse])

  const handleMove = (coors: any) => {
    if (canvas.current) {
      var context = canvas.current.getContext('2d');
      if (context) {
        var deltaX = lastPositionX - coors.x;
        var deltaY = lastPositionY - coors.y;
        var imageData = context.getImageData(deltaX, deltaY, context.canvas.width, context.canvas.height);
        context.putImageData(imageData, 0, 0);
        //context.clearRect(context.canvas.width - deltaX, context.canvas.height - deltaY, deltaX, deltaY);
        setContentLeft(contentLeft - deltaX);
        setContentTop(contentTop - deltaY);
      }
      lastPositionX = coors.x;
      lastPositionY = coors.y;
    }
  }

  const setInitClick = (e: any) => {
    props.setGlobalClicked(props.index);
    if (crop === false) {
      setClicked(true);
    }
    lastPositionX = e.clientX;
    lastPositionY = e.clientY;
  }

  const handleCrop = () => {
    setCrop(true);
  }

  const setInitCropping = (e: any, side: string) => {
    setCropping(side);
    lastPositionX = e.clientX;
    lastPositionY = e.clientY;
  }

  const handleCropping = (coors: any) => {
    if (cropping === 'left') {
      var deltaX = lastPositionX - coors.x;
      setContentLeft(contentLeft - deltaX);
      setContentWidth(contentWidth + deltaX);
    } else if (cropping === 'right'){
      var deltaX = lastPositionX - coors.x;
      setContentWidth(contentWidth - deltaX);
    } else if (cropping === 'top'){
      var deltaY = lastPositionY - coors.y;
      setContentTop(contentTop - deltaY);
      setContentHeight(contentHeight + deltaY);
    } else if (cropping === 'bottom'){
      var deltaY = lastPositionY - coors.y;
      setContentHeight(contentHeight - deltaY);
    }
    lastPositionX = coors.x;
    lastPositionY = coors.y;
  }

  const handleFinalizeCrop = () => {
    if (canvas.current) {
      let context = canvas.current.getContext('2d');
      if (context) {
        let imageData = context.getImageData(contentLeft, contentTop, contentWidth, contentHeight);
        context.clearRect(0, 0, canvas.current.width, canvas.current.height);
        context.putImageData(imageData, contentLeft, contentTop);
      }
    }
    setCrop(false);
  }

  const handleCropOption = () => {
    if (crop) handleFinalizeCrop()
    else handleCrop();
  }

  const handleFinalizeEditText = () => {
    setOpenEdit(false);
  }

  const handleEditText = () => {
    setOpenEdit(true);
  }

  const handleEditTextOption = () => {
    if (openEdit) handleFinalizeEditText()
    else handleEditText();
  }

  const getFontProps = (textProps: any) => {
    var weight = "normal";
    var style = "normal";
    var family = "Roboto";
    var textString = "";
    if (textProps.style?.font) {
      textString = textProps.style.font.name;
    } else if (textProps.styleRuns && textProps.styleRuns.length > 0) {
      var lastStyleRun = textProps.styleRuns[textProps.styleRuns.length - 1];
      if (lastStyleRun.style?.font) {
        textString = lastStyleRun.style.font.name;
      }
    }
    if (textString !== "") {
      var fontValue = textString.toString().split("-");
      if (fontValue && fontValue.length === 2) {
        var fontName: any = fontValue[0].split(/(?=[A-Z])/);
        var fontStyles = fontValue[1].split(/(?=[A-Z])/);
        family = fontName.join(" ");
        if (fontStyles && fontStyles.length > 0) {
          weight = fontStyles[0].toLowerCase();
        }
        if (fontStyles && fontStyles.length > 1) {
          style = fontStyles[1].toLowerCase();
        }
      }
    }
    return {fontStyle: style, fontWeight: weight, fontFamily: family }
  }

  const handleChangeText = (e: any) => {
    if (canvas.current) {
      let ctx = canvas.current.getContext('2d');
      if (ctx) {

        //Deltas %
        const deltaFontHeight = 135;
        const deltaEraseHeight = 110;
        const deltaEraseWidth = 135;

        setText(e.target.value);
        var textProps = props.child.text;
        var fontSize = contentHeight*deltaFontHeight/100;
        var {fontStyle, fontWeight, fontFamily} = getFontProps(textProps);
        var fillColor = '';
        var strokeColor = '';
        if (textProps.style.fillColor)
          fillColor = `rgba(${textProps.style.fillColor.r}, ${textProps.style.fillColor.g}, ${textProps.style.fillColor.b}, ${textProps.style.fillColor.a})`;
        if (textProps.style.strokeColor)
          strokeColor = `rgba(${textProps.style.strokeColor.r}, ${textProps.style.strokeColor.g}, ${textProps.style.strokeColor.b}, ${textProps.style.strokeColor.a})`;
        ctx.font = `${fontStyle} normal ${fontWeight} ${fontSize}px ${fontFamily}`;
        ctx.fillStyle = fillColor !== '' ? fillColor : 'white';
        ctx.strokeStyle = strokeColor !== '' ? strokeColor : 'white';
        //textAlign center, left, right, end, start
        ctx.textAlign = 'start';
        //textBaseline top, hanging, middle, bottom,ideographic, alphabetic
        ctx.textBaseline = 'alphabetic';
        //direction ltr, rtl, inherit
        ctx.direction = 'ltr';
        
        var txt = e.target.value;
        var metrics = ctx.measureText(text);
        var w = metrics.width;
        var eraseWidth = w*deltaEraseWidth/100;
        ctx.clearRect(contentLeft - ((eraseWidth - w)/2), contentTop, eraseWidth, fontSize*deltaEraseHeight/100);
        ctx.fillText(txt, contentLeft, contentTop + contentHeight);
      }
    }
  }

  return (
    <S.Root
      style={{
        width: `${props.dimensions.width}px`,
        height: `${props.dimensions.height}px`
      }}
    >
      <S.CanvasContainer
        id={`${props.fromPreview ? 'preview' : 'canvas'}-${props.index}`} 
        ref={canvas}
      />
      {
        props.previewOnly === false &&
        <S.Box
          onMouseUp={() => props.setGlobalClicked(props.index)}
          style={{
            width: contentWidth,
            height: contentHeight,
            top: contentTop - 1 + 100,
            left: contentLeft - 1 + 100,
            opacity: props.globalClicked === props.index || clicked || crop ? 1 : '',
            zIndex: props.globalClicked === props.index || clicked || crop ? 200 : 100,
          }}
        >
          <S.BoxContainer >
            <S.MoveBox
              onMouseDown={setInitClick}
              style={{
                cursor: clicked ? 'move' : 'auto',
              }}
            />
            {  
              (props.globalClicked === props.index || clicked || crop || openEdit) &&
              <S.OptionsContainer >
                <S.CropMessage
                  onMouseDown={props.child?.text ? handleEditTextOption : handleCropOption}
                >
                  { 
                    props.child?.text ? 
                      openEdit ? 'OK' : 'EDIT' 
                    : 
                      crop ? 'OK' : 'CROP'
                  }
                </S.CropMessage>
              </S.OptionsContainer>
            }
            {
              openEdit &&
              <S.TextBoxContainer style={{top: contentHeight + 10}} >
                <S.TextArea
                  autoFocus
                  value={text}
                  onChange={handleChangeText}
                  cols={30}
                />
              </S.TextBoxContainer>
            }
            <S.LeftSide >
              <S.VerticalBarContainer
                onMouseDown={(e) => setInitCropping(e, "left")}
              >
                <S.VerticalBar />
              </S.VerticalBarContainer>
            </S.LeftSide>
            <S.RightSide >
              <S.VerticalBarContainer
                onMouseDown={(e) => setInitCropping(e, "right")}
              >
                <S.VerticalBar />
              </S.VerticalBarContainer>
            </S.RightSide>
            <S.TopSide >
              <S.HorizontalBarContainer
                onMouseDown={(e) => setInitCropping(e, "top")}
              >
                <S.HorizontalBar />
              </S.HorizontalBarContainer>
            </S.TopSide>
            <S.BottomSide >
              <S.HorizontalBarContainer
                onMouseDown={(e) => setInitCropping(e, "bottom")}
              >
                <S.HorizontalBar />
              </S.HorizontalBarContainer>
            </S.BottomSide>
          </S.BoxContainer>
        </S.Box>
      }
    </S.Root>
  );
}

export default CanvasLayer;